import { Client } from './client.model';
import { Role } from './role.model';

export class Settings {
    [key: string]: any;
    useGeolocation: boolean = false;
    zipCode: string | null;
    selectedDistricts: Array<number> = [];
    selectedBranches: Array<number> = [];
    selectedCustomers: Array<number> = [];
    selectedClientId: number;
    selectedRegions: Array<number> = [];
    selectedProductSortTypeId: string | null;

    constructor(clientId: number) {
        this.selectedClientId = clientId;
    }
}
